import React from 'react';
import './card-about.css'

const Cardabout = (props) => {
    return (
        <article className='cardd-sec-aboutt'>
                <h1 className='timee-about'>{props.date}</h1>
                <h2 className='text-card-about'>{props.task}</h2>
        </article>
      );
}
 
export default Cardabout;